export default __webpack_public_path__ + "static/OpenSans-Light-9405e3d0d19c1cf91badc55d90420e5a.ttf";